// Constants
import { APIBBC, APICCT } from 'src/constants/quotationOrigin';

// Icons
import {
  CollaboratorIcon,
  AgentIcon,
  CalculatorIcon,
  B2BIcon,
  PersonalLinkIcon,
} from '../components/Icons';

function renderRoleIcon(
  role: string,
  origin: string,
  fromPersonalLink: boolean,
): JSX.Element {
  if (fromPersonalLink) {
    return <PersonalLinkIcon data-testid="personal-link-icon" />;
  }

  if (origin === APICCT) {
    return <CalculatorIcon data-testid="calculator-icon" />;
  }

  if (origin === APIBBC) {
    return <B2BIcon data-testid="b2b-icon" />;
  }

  return role === 'AGE' ? (
    <AgentIcon data-testid="agent-icon" />
  ) : (
    <CollaboratorIcon data-testid="collab-icon" />
  );
}

export default renderRoleIcon;
